import { EconomicsSettingsCalculationTypeBase } from './base/economics-settings-calculation-type-base';

export class EconomicsSettingsCalculationType extends EconomicsSettingsCalculationTypeBase { }